export default __webpack_public_path__ + "static/media/background_mk2.377f2d75.jpg";